'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _AlertTwoTone = require('./lib/icons/AlertTwoTone');
  
  
  var _default = _AlertTwoTone;
  exports.default = _default;
  module.exports = _default;